import { TextArea, TextField } from "../components/TextField";
import { Button } from "../components/Button";
import { Select } from "../components/Select";
import { Form } from "react-router-dom";
import { addSubscription } from "../services/api";
import { useEffect, useState } from "react";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";

export async function AddSubscriptionAction ({request}){
	// alert('request');
	// return 1;
	try{

	const data = await request.formData();
	const formToJSON = {};
	for (const [key, value] of [...data.entries()]) {
	formToJSON[key] = value;
	}
  	const response = await addSubscription(formToJSON);


	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result = await response.text();
	alert("Added Subscription package");
	} catch(e){
		console.log("error", e);
		if (e.response) {
			const errorBody = await e.response.json();
			console.log("error body", errorBody);
		}
	}
}

export function AddSubscription(){
	const [isQuarterAvailable, setIsQuarterAvailable] = useState(true);
	const [isSemiAvailable, setIsSemiAvailable] = useState(true);
	const [isAnnualAvailable, setIsAnnualAvailable] = useState(true);
	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);
	return (
	<main id="AddMember">
		<h1>Add A Subscription</h1>

		<Form method="post"  encType="multipart/form-data">
			{/* Member bio card  */}
			<div className="card">
				<p className="label">Membership Plan Details</p>
				<div className="col" >


					<TextField
					label="Plan Name"
					// value="kweku"
					name="plan_name"
					/>
					<TextArea
					label="Plan Description & Details"
					name="description"
					/>
				</div>

			</div>

			{/* Vehicle Details  */}
			<div className="card">
				<p className="label">Quarterly Plan</p>

				<div className="checkbox-div">
					<input type="checkbox" name="quarterly_available" id="quarterly_available"  checked={isQuarterAvailable} onChange={()=>setIsQuarterAvailable(!isQuarterAvailable)}/>
					<label htmlFor="quarterly_available">Is available</label>
				</div>
				{isQuarterAvailable && <div className="row space-between grid-3x3">

					<Select
					options={["GHS","USD"]}
					name="quarterly_currency"
					label="Currency"
					/>
					<TextField
					label="Amount"
					name="quarterly_amount"
					// value="acquaye"
					/>
				</div>}

			</div>

			{/* Vehicle Details  */}
			<div className="card">
				<p className="label">Semi-annual Plan</p>

				<div className="checkbox-div">
					<input type="checkbox" name="semi_available" id="semi_available"  checked={isSemiAvailable} onChange={()=>setIsSemiAvailable(!isSemiAvailable)}/>
					<label htmlFor="semi_available">Is available</label>
				</div>
				{isSemiAvailable && <div className="row space-between grid-3x3">

					<Select
					options={["GHS","USD"]}
					name="semi_currency"
					label="Currency"
					/>
					<TextField
					label="Amount"
					name="semi_amount"
					// value="acquaye"
					/>
				</div>}

			</div>

			{/* Vehicle Details  */}
			<div className="card">
				<p className="label">Annual Plan</p>

				<div className="checkbox-div">
					<input type="checkbox" name="annual_available" id="annual_available" checked={isAnnualAvailable} onChange={()=>setIsAnnualAvailable(!isAnnualAvailable)}/>
					<label htmlFor="annual_available">Is available</label>
				</div>
				{isAnnualAvailable && <div className="row space-between grid-3x3">

					<Select
					options={["GHS","USD"]}
					name="annual_currency"
					label="Currency"
					/>
					<TextField
					label="Amount"
					name="annual_amount"
					// value="acquaye"
					/>
				</div>}

			</div>


			<Button
			label="Add Subscription"
			color="blue"
			type="submit"
			// onClick={()=>{alert('submit')}}
			/>
		</Form>
	</main>)
}


// currency: "GHS"
// description: "We give good stuff"
// duration: "biannually"
// is_available: 1
// option_id: 7
// plan_id: 4
// plan_name: "Gold"
// price: "405.00"